module.exports = __webpack_public_path__ + "img/1516724990.730c64af.jpg";